import React from 'react'
import Experiment from '@mc/experiments-react'
import { StickyFooter } from 'components/StickyFooter'
import { HP_INNOVATIVE_SWING_FLAG_NAME } from './constants'

export const StickyFooterExpWrapper = () => (
  <Experiment
    name={HP_INNOVATIVE_SWING_FLAG_NAME}
    control={() => null}
    default={StickyFooter}
    track={false}
  />
)
